<template>
  <div class="container mt-4">
    <h2>Cadastro de Conta Bancária</h2>

    <b-form @submit.prevent="submitForm">
      <b-row>
        <b-col>
          <b-form-group label-for="accountName" label="Apelido da conta">
            <b-form-input
              v-model="bankAccount.accountName"
              type="text"
              :state="!!bankAccount.accountName"
              id="accountName"
              placeholder="Informe o apelido da conta"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="1">
          <b-form-group label-for="status" label="Status">
            <b-form-checkbox v-model="bankAccount.active" id="status" switch>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group label-for="initialBalance" label="Saldo Inicial">
            <base-input-numeric
              :value.sync="bankAccount.initialBalance"
            ></base-input-numeric>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label-for="startDate" label="Data de inicio">
            <b-form-input
              v-model="bankAccount.startDate"
              type="date"
              id="startDate"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            label-for="holderDocumentNumber"
            label="Documento do titular"
          >
            <b-form-input
              v-model="bankAccount.holderDocumentNumber"
              type="text"
              :state="!!bankAccount.holderDocumentNumber"
              id="holderDocumentNumber"
              placeholder="Informe o código do titular da conta"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-for="accountType" label="Tipo da conta">
            <b-form-select
              v-model="bankAccount.accountType"
              :options="accountTypeOptions"
              placeholder="Informe o tipo da conta"
              :state="!!bankAccount.accountType"
              id="productType"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group label-for="bankId" label="Banco">
            <b-form-select
              v-model="bankAccount.bank.id"
              :options="bankOptions"
              placeholder="Informe o tipo do serviço"
              :state="!!bankAccount.bank.id"
              id="productType"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <div v-if="this.bankAccount.bank.id == 'new'">
        <hr />
        <h3>Banco</h3>
        <b-row>
          <b-col>
            <b-form-group label-for="bacen" label="Código BACEN">
              <b-form-input
                v-model="bankAccount.bank.bacen"
                type="text"
                id="bacen"
                v-mask="'999'"
                maxlength="3"
                :state="!!bankAccount.bank.bacen"
                placeholder="Informe o código bacen da conta"
                @input="getBank"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group
              label-for="name"
              :label="isLoadingBank ? 'Buscando Nome...' : 'Nome'"
            >
              <b-form-input
                v-model="bankAccount.bank.name"
                type="text"
                id="name"
                placeholder="Informe o apelido da conta"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="2">
            <b-button variant="primary" class="mt-4" block @click="addNewBank">
              Salvar
            </b-button>
          </b-col>
        </b-row>
        <hr />
      </div>
      <b-button variant="primary" @click="addNewBankAccount">
        Salvar
      </b-button>

      <fade-alert-danger
        ref="fadeAlertDanger"
        :msg="alert.error"
      ></fade-alert-danger>
      <success-fade-alert
        ref="successFadeAlert"
        :msg="alert.success"
      ></success-fade-alert>
    </b-form>
  </div>
</template>
<script>
import BaseInputNumeric from "../../../../components_rms/base/BaseInputNumeric.vue";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
import AwesomeMask from "awesome-mask";
import datetimeMixin from "@/mixins/datetime.js";

export default {
  name: "ServiceCrud",
  mixins: [datetimeMixin],
  components: {
    BaseInputNumeric,
    FadeAlertDanger,
    SuccessFadeAlert
  },
  directives: {
    mask: AwesomeMask
  },
  data() {
    return {
      alert: {
        error: "Verifique os dados informados",
        success: "Banco cadastrado com sucesso!"
      },
      bankAccount: {
        id: null,
        bank: {
          id: null,
          name: "",
          bacen: null,
          createByUserId: null,
          createAt: Date.now(),
          updateByUserId: null,
          updateAt: Date.now()
        },
        accountName: "",
        initialBalance: 0,
        balance: 0,
        startDate: this.getToday(),
        accountType: 0,
        holderDocumentNumber: null,
        active: true,
        createByUserId: null,
        createAt: Date.now(),
        updateByUserId: null,
        updateAt: Date.now()
      },

      bankOptions: [{ text: " Adicionar + ", value: "new" }],
      accountTypeOptions: [
        { text: "Corrente", value: 1 },
        { text: "Poupança", value: 2 }
      ],
      isLoadingBank: false
    };
  },
  created() {
    if (this.$route?.params?.rowData)
      this.product = JSON.parse(this.$route.params.rowData);
  },
  mounted() {
    this.getAllBanks();
  },
  methods: {
    validateBankAccount() {
      const errors = [];

      if (
        !this.bankAccount.accountName ||
        !this.bankAccount.accountName.trim()
      ) {
        errors.push("Por favor, insira um apelido para conta");
      }

      if (
        !this.bankAccount.holderDocumentNumber ||
        !this.bankAccount.holderDocumentNumber.trim()
      ) {
        errors.push("Por favor, insira o documento do titular");
      }
      if (!this.bankAccount.bank.id) {
        errors.push("Por favor, selecione um banco");
      }

      return errors;
    },
    cleanBankAccount() {
      this.bankAccount = {
        id: null,
        bank: {
          id: null,
          name: "",
          bacen: null,
          createByUserId: null,
          createAt: Date.now(),
          updateByUserId: null,
          updateAt: Date.now()
        },
        accountName: "",
        initialBalance: 0,
        balance: 0,
        startDate: null,
        accountType: 0,
        holderDocumentNumber: null,
        active: true,
        createByUserId: null,
        createAt: Date.now(),
        updateByUserId: null,
        updateAt: Date.now()
      };
    },

    addNewBankAccount() {
      const validationErrors = this.validateBankAccount();

      if (validationErrors.length) {
        this.alert.error = validationErrors[0];
        this.$refs.fadeAlertDanger.show();
        return;
      }

      const url = this.$route.params.edit
        ? "/bankaccount/edit"
        : "/bankaccount/create";

      this.$apiScheduler
        .post(url, this.bankAccount)
        .then(response => {
          this.alert.success = "Conta bancária salva com sucesso!";
          this.$refs.successFadeAlert.show();
          this.cleanBankAccount();
        })
        .catch(error => {
          this.alert.error = error.response.data.split("-")[0];
          this.$refs.fadeAlertDanger.show();
        });
    },
    async getBank() {
      if (this.bankAccount.bank.bacen.length === 3) {
        try {
          const response = await fetch(
            `https://brasilapi.com.br/api/banks/v1/${this.bankAccount.bank.bacen}`
          );

          if (!response.ok) {
            throw new Error("Banco não encontrado");
          }

          const data = await response.json();
          this.bankAccount.bank.name = data.name;
          this.isLoadingBank = false;
        } catch (error) {
          this.isLoadingBank = false;
          console.error("Erro ao buscar banco:", error);
          this.bankAccount.bank.name = "";
        }
      }
    },
    async getAllBanks() {
      try {
        const response = await this.$apiScheduler.get(`/bank/all`);
        response.data.forEach(element => {
          this.bankOptions.push({ text: element.name, value: element.id });
        });
      } catch (error) {
        console.error("Erro ao carregar estados:", error);
      }
    },
    addNewBank() {
      console.log("Salvar banco:", this.bankAccount.bank);
      this.$apiScheduler
        .post("/bank/create", this.bankAccount.bank)
        .then(response => {
          this.bankOptions.push({
            text: this.bankAccount.bank.name,
            value: response.data.id
          });
          this.bankAccount.bank.id = response.data.id;
          this.$refs.successFadeAlert.show();
        })
        .catch(error => {
          this.alert.error = error.response.data.split("-")[0];
          this.$refs.fadeAlertDanger.show();
        });
    }
  }
};
</script>
